import React, { useEffect, useState } from "react";
import '../assets/style/lywo-style.css';
// import { Icons } from '../ui/Icons';

// import React from 'react';
// ==========================================
// 1. ICONS (Inline SVGs for Portability)
// ==========================================
export const Icons = {
  ArrowLeft: (props) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="m12 19-7-7 7-7" /><path d="M19 12H5" />
    </svg>
  ),
  Briefcase: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect width="20" height="14" x="2" y="7" rx="2" ry="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  Building2: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" /><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" /><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" /><path d="M10 6h4" /><path d="M10 10h4" /><path d="M10 14h4" /><path d="M10 18h4" />
    </svg>
  ),
  BadgeCheck: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.78 4.78 4 4 0 0 1-6.74 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" /><path d="m9 12 2 2 4-4" />
    </svg>
  ),
  UploadCloud: (props) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" /><path d="M12 12v9" /><path d="m16 16-4-4-4 4" />
    </svg>
  ),
  ChevronRight: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="m9 18 6-6-6-6" />
    </svg>
  ),
  User: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Mail: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  ),
  MapPin: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" />
    </svg>
  ),
  Calendar: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect width="18" height="18" x="3" y="4" rx="2" ry="2" /><line x1="16" x2="16" y1="2" y2="6" /><line x1="8" x2="8" y1="2" y2="6" /><line x1="3" x2="21" y1="10" y2="10" />
    </svg>
  ),
  Zap: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  ),
  FileText: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" /><polyline points="14 2 14 8 20 8" /><line x1="16" x2="8" y1="13" y2="13" /><line x1="16" x2="8" y1="17" y2="17" /><line x1="10" x2="8" y1="9" y2="9" />
    </svg>
  ),
  CheckCircle: (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  Loader2: (props) => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  ),
  Check: (props) => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  Sparkles: (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="none" {...props}>
      <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
    </svg>
  ),
  X: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M18 6 6 18" /><path d="m6 6 18 12" />
    </svg>
  ),
  Info: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" />
    </svg>
  ),
  Clock: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Download: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" x2="12" y1="15" y2="3" />
    </svg>
  ),
  Share2: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><line x1="8.59" x2="15.42" y1="13.51" y2="17.49" /><line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
    </svg>
  ),
  UserPlus: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="8.5" cy="7" r="4" /><line x1="20" x2="20" y1="8" y2="14" /><line x1="23" x2="17" y1="11" y2="11" />
    </svg>
  ),
  Edit: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
    </svg>
  ),
  Link: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  ),
  Linkedin: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" /><rect width="4" height="12" x="2" y="9" /><circle cx="4" cy="4" r="2" />
    </svg>
  ),
  WhatsApp: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="12" cy="12" r="10" /><path d="M16.5 16.5 12 12" />
    </svg>
  ),
  ThumbsUp: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M7 10v12" /><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z" />
    </svg>
  ),
  Money: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M6 3h12" /><path d="M6 8h12" /><path d="m6 13 8.5 10" /><path d="M9 13c6.668 0 6.668-9 0-9H6" />
    </svg>
  ),
  Star: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
};


// --- 2. CUSTOM CSS ---
// const CUSTOM_CSS = `
// @charset "UTF-8";
// @import url("https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css");
// @import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

// :root {
//   /* --- Brand Colors --- */
//   --brand-primary: #0d6efd;
//   --brand-bg: #f5f8ff;
//   --brand-text: #212529;
  
//   /* --- Semantic Colors --- */
//   --color-info-bg: #eef2ff;
//   --color-success-bg: #d1e7dd; --color-success-text: #198754;
//   --color-warning-bg: #fff3cd; --color-warning-text: #856404;
//   --color-danger-bg: #f8d7da; --color-danger-text: #dc3545;
  
//   /* --- UI Neutrals --- */
//   --ui-gray-bg: #F2F4F7;
//   --ui-border: #d0d5dd;
//   --ui-text-muted: #667085;
//   --ui-text-dark: #344054;

//   /* --- Dimensions --- */
//   --radius-md: 0.5rem;
//   --radius-lg: 0.75rem;

//   /* ========================================================= */
//   /* TYPOGRAPHY SEMANTIC TOKENS (Contextual Scale)             */
//   /* Base size: 11px (0.6875rem) for complex/dense data UI     */
//   /* ========================================================= */
//   --font-size-xs: 0.5rem; /* ~8px */
//   --font-size-base: 0.6875rem; /* ~11px */
//   --font-size-lg: 0.875rem; /* ~14px */
//   --font-size-xl: clamp(1rem, 0.9rem + 0.5vw, 1.1875rem); /* ~16-19px */
//   --font-size-2xl: clamp(1.25rem, 1.1rem + 1vw, 1.5rem); /* ~20-24px */
//   --font-size-3xl: clamp(1.5rem, 1.2rem + 1.5vw, 1.9375rem); /* ~24-31px */

//   --line-height-heading: 1.2; /* Tight for impact */
//   --line-height-body: 1.5; /* Loose for readability */
// }

// html { 
//   scroll-behavior: smooth; 
//   /* Rely on root font-size (usually 16px) for rem scaling */
//   font-size: 100%; 
// }

// body { 
//   margin: 0; padding: 0; 
//   font-family: 'Inter', sans-serif !important; 
//   font-size: var(--font-size-base); 
//   background-color: var(--bs-body-bg); 
//   -webkit-font-smoothing: antialiased; 
//   line-height: var(--line-height-body); 
//   color: var(--brand-text);
//   font-weight: 400; /* Regular weights for body */
// }

// /* Responsive Images */
// img { max-width: 100%; height: auto; }

// /* CSS Grid Utilities for Responsive Layouts */
// .grid-responsive { display: grid; grid-template-columns: 1fr; gap: 1.5rem; }
// @media (min-width: 768px) { .grid-responsive { grid-template-columns: repeat(2, 1fr); } }
// @media (min-width: 1024px) { .grid-responsive { grid-template-columns: repeat(3, 1fr); } }

// /* ========================================= */
// /* TYPOGRAPHY GLOBAL STYLES                  */
// /* ========================================= */

// /* Headers (Bolder weights, tighter line heights) */
// h1, .h1, .text-3xl { font-size: var(--font-size-3xl) !important; line-height: var(--line-height-heading); font-weight: 700; letter-spacing: -0.02em; }
// h2, .h2, .text-2xl { font-size: var(--font-size-2xl) !important; line-height: var(--line-height-heading); font-weight: 700; letter-spacing: -0.01em; }
// h3, .h3, .text-xl  { font-size: var(--font-size-xl) !important; line-height: var(--line-height-heading); font-weight: 700; }
// h4, .h4, .text-lg  { font-size: var(--font-size-lg) !important; line-height: 1.3; font-weight: 700; }

// /* Body Text */
// p {
//   font-size: var(--font-size-base) !important; 
//   line-height: var(--line-height-body); 
//   text-align: left; 
//   /* Optimize line length: 50-75 characters per line */
//   max-inline-size: 75ch; 
//   margin-bottom: 1rem;
// }
// .text-base { font-size: var(--font-size-base) !important; }
// small, .small, .text-xs { font-size: var(--font-size-xs) !important; line-height: var(--line-height-body); }

// /* Font Weights */
// .fw-bold { font-weight: 700 !important; }
// .fw-normal { font-weight: 400 !important; }
// .fw-medium { font-weight: 500 !important; }

// /* Text Colors */
// .text-primary { color: var(--brand-primary) !important; }
// .text-danger { color: var(--color-danger-text) !important; }
// .text-warning { color: #f97316 !important; }
// .text-info { color: #ca8a04 !important; }
// .text-muted { color: var(--ui-text-muted) !important; }
// .text-center { text-align: center !important; }
// .icon-baseline { margin-top: 4px; display: inline-block; line-height: 0; }

// /* Layout & Preview Overrides */
// .ds-wrapper { background-color: var(--brand-bg); min-height: 100vh; display: flex; flex-direction: column; min-width: 320px; }
// .ds-wrapper.desktop-preview { min-width: 1024px; overflow-x: auto; }

// .ds-header { background: #fff; border-bottom: 1px solid var(--ui-border); position: sticky; top: 0; z-index: 1000; }
// .ds-brand-row { display: flex; justify-content: space-between; align-items: center; padding: 0.75rem 1.5rem; border-bottom: 1px solid var(--ui-gray-bg); }
// .ds-nav-row { padding: 0 1.5rem; overflow-x: auto; white-space: nowrap; background: #fff; }
// .ds-content { flex: 1; padding: 2rem; width: 100%; max-width: 1200px; margin: 0 auto; }

// /* Step One Clean override to retain previous layout */
// .content-area.step-one-clean { background: transparent; border: none; box-shadow: none; padding-bottom: 20px; }

// /* Tabs */
// .nav-tabs-horizontal { display: flex; gap: 2rem; border-bottom: none; margin: 0; padding: 0; list-style: none; }
// .nav-item-h { padding: 1rem 0.25rem; cursor: pointer; color: var(--ui-text-muted); font-weight: 500; font-size: var(--font-size-lg); border-bottom: 2px solid transparent; transition: all 0.2s; display: flex; align-items: center; gap: 0.5rem; }
// @media (hover: hover) { .nav-item-h:hover { color: var(--brand-primary); } }
// .nav-item-h.active { color: var(--brand-primary); border-bottom-color: var(--brand-primary); }

// /* Buttons */
// .btn { font-weight: 600; padding: 0.5rem 1rem; border-radius: var(--radius-md); display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; transition: 0.2s; font-size: 0.8125rem; /* ~13px */ cursor: pointer; border: 1px solid transparent; }
// .btn-primary { background-color: var(--brand-primary); border-color: var(--brand-primary); color: #fff; box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05); }
// .btn-primary:disabled { background-color: #93c5fd; border-color: #93c5fd; cursor: not-allowed; transform: none; }
// .btn-outline-primary { color: var(--brand-primary); border-color: var(--brand-primary); background: #fff; }
// .btn-icon { padding: 8px; color: var(--ui-text-muted); border: 1px solid var(--ui-border); background: #fff; }

// @media (hover: hover) {
//   .btn-primary:hover { background-color: #0b5ed7; transform: translateY(-1px); }
//   .btn-outline-primary:hover { background-color: var(--color-info-bg); }
//   .btn-icon:hover { color: var(--brand-primary); border-color: var(--brand-primary); background: var(--color-info-bg); }
// }

// /* Pagination */
// .pagination-wrapper { display: flex; justify-content: flex-end; align-items: center; gap: 1.5rem; padding: 1rem 0; width: 100%; }
// .pagination-nav { display: flex; align-items: center; gap: 0.5rem; }
// .page-nav-link { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; color: var(--ui-text-muted); cursor: pointer; background: transparent; border: 1px solid transparent; border-radius: 6px; font-size: var(--font-size-lg); transition: all 0.2s; }
// .page-nav-link.disabled { opacity: 0.4; cursor: not-allowed; pointer-events: none; }
// @media (hover: hover) { .page-nav-link:hover { color: var(--brand-primary); background-color: var(--ui-gray-bg); } }
// .page-number { font-weight: 500; font-size: var(--font-size-lg); color: var(--brand-text); cursor: pointer; }
// .page-select-wrapper { position: relative; display: flex; align-items: center; }
// .page-select { appearance: none; padding: 6px 28px 6px 12px; border: 1px solid var(--ui-border); border-radius: 6px; background: #fff; font-size: 0.8125rem; font-weight: 500; color: var(--brand-text); cursor: pointer; min-width: 80px; }
// .page-select:focus { outline: none; border-color: var(--brand-primary); }
// .page-select-icon { position: absolute; right: 8px; pointer-events: none; width: 14px; height: 14px; color: var(--ui-text-muted); }

// /* Forms */
// .form-control, .form-select { color: #344054; font-size: 0.75rem; /* ~12px */ font-weight: 500; border-radius: 8px; min-height: 38px; border: 1px solid var(--ui-border); padding: 0.375rem 0.75rem; background: #fff; }
// .form-control:focus { outline: none; border-color: var(--brand-primary); box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.15); }
// .form-label { font-size: var(--font-size-base); font-weight: 500; color: #344054; margin-bottom: 4px; display: block; }
// .otp-input { width: 50px; height: 50px; text-align: center; font-size: 1.25rem; font-weight: 600; border-radius: 8px; border: 1px solid var(--ui-border); background: #fff; color: var(--brand-text); }
// .otp-input:focus { border-color: var(--brand-primary); box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.15); outline: none; }
// .input-title-large { display: block; width: 100%; padding: 12px 16px; font-size: var(--font-size-3xl); font-weight: 600; line-height: 1.2; color: var(--brand-text); background-color: #fff; border: 1px solid var(--ui-border); border-radius: var(--radius-md); transition: all 0.2s ease-in-out; }
// .input-title-large:focus { border-color: var(--brand-primary); box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.15); outline: none; }

// /* Touch Target Expansion */
// @media (pointer: coarse) {
//   .btn, .form-control, .form-select, .page-nav-link, .nav-item-h, .context-menu-item { 
//     min-height: 44px; padding-top: 10px; padding-bottom: 10px;
//   }
// }

// /* Topic Chips */
// .topic-chip { display: inline-flex; align-items: center; padding: 6px 14px; border-radius: 50rem; font-size: var(--font-size-base); font-weight: 500; cursor: pointer; border: 1px solid var(--ui-border); background-color: #fff; color: var(--brand-text); transition: all 0.2s ease; }
// @media (hover: hover) { .topic-chip:hover { background-color: var(--ui-gray-bg); } }
// .topic-chip.selected { background-color: var(--brand-primary); border-color: var(--brand-primary); color: #fff; }
// .topic-chip.sub { font-size: 0.625rem; padding: 4px 10px; border-color: #e5e7eb; }
// .topic-chip.sub.selected { background-color: var(--color-info-bg); color: var(--brand-primary); border-color: var(--brand-primary); }
// .input-with-action-icon { position: absolute; top: 50%; right: 12px; transform: translateY(-50%); color: var(--ui-text-muted); cursor: pointer; }
// .input-with-action-icon:hover { color: var(--brand-primary); }

// /* Contextual Menu */
// .context-menu { background: #fff; border: 1px solid var(--ui-border); border-radius: 8px; box-shadow: 0 4px 12px -2px rgba(0,0,0,0.1); min-width: 180px; padding: 4px 0; overflow: hidden; }
// .context-menu-item { display: flex; align-items: center; gap: 8px; padding: 6px 12px; font-size: 0.8125rem; font-weight: 500; color: var(--brand-text); cursor: pointer; transition: 0.1s; }
// .context-menu-item.danger { color: var(--color-danger-text); }
// @media (hover: hover) {
//   .context-menu-item:hover { background-color: var(--ui-gray-bg); color: var(--brand-primary); }
//   .context-menu-item.danger:hover { background-color: #fef2f2; }
// }

// /* Badges */
// .badge { display: inline-flex; align-items: center; padding: 4px 12px; border-radius: 9999px; font-size: 0.75rem; font-weight: 600; line-height: 1; border: 1px solid transparent; }
// .badge-excellent { background-color: var(--color-success-bg); color: var(--color-success-text); border-color: var(--color-success-bg); }
// .badge-good { background-color: var(--color-info-bg); color: var(--brand-primary); border-color: var(--color-info-bg); }
// .badge-normal { background-color: var(--color-warning-bg); color: var(--color-warning-text); border-color: var(--color-warning-bg); }
// .badge-poor { background-color: var(--color-danger-bg); color: var(--color-danger-text); border-color: var(--color-danger-bg); }

// /* Cards & Modules */
// .card-std { background: #fff; border: 1px solid var(--ui-border); border-radius: 12px; padding: 16px; transition: 0.3s; position: relative; margin-bottom: 1rem; height: 100%; }
// .card-interactive { cursor: pointer; transition: all 0.2s; border: 1px solid transparent; }
// @media (hover: hover) { .card-interactive:hover { border-color: var(--brand-primary) !important; background-color: #f8faff; transform: translateY(-2px); } }
// .card-interactive.selected { border-color: var(--brand-primary) !important; background-color: var(--color-info-bg); }
// .card-select { background: #fff; border: 1px solid var(--ui-border); border-radius: 12px; padding: 24px; cursor: pointer; transition: 0.2s; position: relative; }
// @media (hover: hover) { .card-select:hover { border-color: var(--brand-primary); transform: translateY(-2px); } }
// .card-select.selected { border-color: var(--brand-primary); background-color: var(--color-info-bg); box-shadow: 0 0 0 1px var(--brand-primary); }
// .card-select.wide { width: 100%; max-width: 600px; }
// .card-select-header { text-align: center; margin-bottom: 12px; }
// .card-select-header h4 { margin: 0; font-size: var(--font-size-xl); font-weight: 600; color: var(--brand-text); }
// .information-card { display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 4px 12px; border-radius: 6px; background-color: var(--color-warning-bg); color: var(--color-warning-text); border: 1px solid var(--color-warning-text); font-size: var(--font-size-base); font-weight: 600; line-height: 1.25; }
// .card-pricing { border: 1px solid var(--ui-border); border-radius: 12px; padding: 1.5rem; background: #fff; transition: all 0.2s; height: 100%; position: relative; display: flex; flex-direction: column; justify-content: space-between; }
// @media (hover: hover) { .card-pricing:hover { transform: translateY(-4px); box-shadow: 0 12px 24px rgba(0,0,0,0.1); } }
// .card-pricing.standard { border-color: var(--brand-primary); background-color: #f8faff; }
// .card-pricing.premium { border-color: var(--color-success-text); background-color: #f0fdf4; }
// .badge-floating { position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%); background-color: var(--color-success-text); color: white; font-size: 0.75rem; font-weight: 600; padding: 4px 12px; border-radius: 20px; white-space: nowrap; box-shadow: 0 2px 4px rgba(0,0,0,0.1); }
// .kanban-board { display: flex; gap: 20px; overflow-x: auto; padding-bottom: 20px; }
// .kanban-col { flex: 0 0 300px; background: #F9FAFB; border-radius: 12px; padding: 16px; border: 1px solid var(--ui-border); }
// .kanban-col-header { display: flex; justify-content: space-between; margin-bottom: 16px; font-size: var(--font-size-lg); font-weight: 600; color: #475467; }
// .kanban-item { background: #fff; border: 1px solid var(--ui-border); border-radius: 8px; padding: 16px; margin-bottom: 12px; box-shadow: 0 1px 2px rgba(0,0,0,0.05); }
// .chat-window { background: #fff; border: 1px solid var(--ui-border); border-radius: 12px; overflow: hidden; height: 500px; display: flex; flex-direction: column; }
// .chat-msg { max-width: 75%; padding: 12px 16px; border-radius: 12px; font-size: var(--font-size-lg); line-height: var(--line-height-body); margin-bottom: 10px; }
// .chat-msg.received { background: #fff; border: 1px solid var(--ui-border); border-bottom-left-radius: 2px; align-self: flex-start; color: var(--brand-text); }
// .chat-msg.sent { background: var(--color-info-bg); color: #1e3a8a; border: 1px solid #bfdbfe; border-bottom-right-radius: 2px; align-self: flex-end; margin-left: auto; }
// .VWOcard { position: relative; width: 100%; min-height: 160px; background-color: #ffffff; border-radius: 8px; padding: 16px 0; box-shadow: 0px 4px 6px 2px #10182808; display: flex; align-items: center; justify-content: center; flex-direction: column; gap: 8px; border: 1px solid transparent; }
// .VWOcard p { font-size: 0.75rem; font-weight: 600; color: var(--ui-text-muted); margin: 0; }
// .orngBrdr { border: 2px solid #f97066; }
// .btnVldt { display: flex; align-items: center; justify-content: center; width: 100%; border-radius: 8px; border: 1px solid var(--brand-indigo); padding: 10px 16px; background-color: var(--brand-indigo); color: #fff; cursor: pointer; }
// .candListBox { background-color: #ffffff; border-radius: 12px; border: 1px solid var(--ui-border); padding: 16px; }
// .candListHdr { border-bottom: 1px solid var(--ui-border); padding-bottom: 12px; margin-bottom: 12px; display: flex; justify-content: space-between; align-items: center; }

// /* Ant Table Styles */
// .table-container { border: 1px solid var(--ui-border); border-radius: 8px; overflow: hidden; background: #fff; }
// .ant-table { width: 100%; border-collapse: collapse; }
// .ant-table th { background: #fafafa; padding: 6px 8px; text-align: left; font-weight: 700; font-size: var(--font-size-base); color: var(--brand-text); border-bottom: 1px solid var(--ui-border); cursor: pointer; transition: background 0.2s; }
// @media (hover: hover) { .ant-table th:hover { background: #f0f0f0; } }
// .ant-table td { padding: 6px 8px; font-size: var(--font-size-base); color: #344054; border-bottom: 1px solid var(--ui-border); }
// .ant-table tr:last-child td { border-bottom: none; }
// @media (hover: hover) { .ant-table tr:hover td { background-color: #fafafa; } }
// .ant-header-content { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
// .ant-icons { display: flex; flex-direction: column; gap: 0px; color: var(--ui-text-muted); }
// .ant-icon-up, .ant-icon-down { width: 10px; height: 10px; opacity: 0.5; }
// .ant-icon-active { opacity: 1; color: var(--brand-primary); }
// .ant-filter { color: var(--ui-text-muted); width: 12px; height: 12px; opacity: 0.6; }
// @media (hover: hover) { .ant-filter:hover { opacity: 1; color: var(--brand-primary); } }

// /* Rich Text Editor */
// .rich-text-editor { border: 1px solid var(--ui-border); border-radius: var(--radius-md); overflow: hidden; background: #fff; }
// .rte-toolbar { display: flex; gap: 8px; padding: 8px; border-bottom: 1px solid var(--ui-border); background: #f8f9fa; }
// .rte-btn { padding: 4px; border-radius: 4px; color: var(--ui-text-muted); cursor: pointer; }
// @media (hover: hover) { .rte-btn:hover { background: var(--ui-gray-bg); color: var(--brand-primary); } }
// .rte-btn.active { background: var(--ui-gray-bg); color: var(--brand-primary); }
// .rte-content { padding: 12px; min-height: 120px; color: var(--brand-text); font-size: var(--font-size-base); }

// /* MODAL STYLES & Glassmorphism */
// .custom-modal-overlay { position: fixed; inset: 0; background-color: rgba(0,0,0,0.5); backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); z-index: 1050; display: flex; align-items: center; justify-content: center; animation: fadeIn 0.2s ease-out; }
// .custom-modal-dialog { background: #fff; width: 100%; max-height: 90vh; border-radius: var(--radius-lg); box-shadow: 0 10px 25px rgba(0,0,0,0.1); display: flex; flex-direction: column; overflow: hidden; animation: slideUp 0.3s ease-out; z-index: 1051; }
// .custom-modal-header { padding: 0.5rem 1.5rem; border-bottom: 1px solid var(--ui-border); display: flex; justify-content: space-between; align-items: center; background: #fff; }
// .custom-modal-body { padding: 1.5rem; flex: 1; overflow-y: auto; background: #fff; }
// .custom-modal-footer { padding: 1rem 1.5rem; border-top: 1px solid var(--ui-border); background: #f8f9fa; display: flex; justify-content: space-between; gap: 1rem; }
// .anim-fade { animation: fadeIn 0.3s ease-out; }

// /* Sticky Footer Glassmorphism */
// .sticky-action-bar { position: fixed; bottom: 0; left: 0; width: 100%; padding: 1rem 1.5rem; border-top: 1px solid rgba(208, 213, 221, 0.6); background: rgba(255, 255, 255, 0.65); backdrop-filter: blur(16px) saturate(180%); -webkit-backdrop-filter: blur(16px) saturate(180%); box-shadow: 0 -4px 24px -6px rgba(0,0,0,0.08); z-index: 1020; }

// /* Toasts */
// .toast-container { position: absolute; bottom: 20px; right: 20px; z-index: 1100; display: flex; flex-direction: column; gap: 10px; }
// .toast { background: #fff; border: 1px solid var(--ui-border); border-radius: 8px; padding: 12px 16px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); display: flex; align-items: center; gap: 12px; min-width: 300px; animation: slideInRight 0.3s ease-out; }
// @keyframes slideInRight { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
// @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
// @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

// /* ==========================================================================
//    ADDED UTILITY CLASSES FOR LAYOUT (Zero hardcoded text sizing)
//    ========================================================================== */
// .z-10 { z-index: 10; }
// .z-1060 { z-index: 1060; }
// .z-1020 { z-index: 1020; }
// .progress-thin { height: 6px; }
// .cursor-pointer { cursor: pointer; }
// .modal-md { max-width: 500px; }
// .modal-lg { max-width: 600px; }
// .modal-body-scroll { max-height: 70vh; overflow-y: auto; }
// .h-auto { height: auto !important; }
// .avatar-56 { width: 56px; height: 56px; flex-shrink: 0; }
// .logo-text { letter-spacing: 0.5px; }
// .max-w-400 { max-width: 400px; margin: 0 auto; }
// .max-w-500 { max-width: 500px; margin: 0 auto; }
// .max-w-900 { max-width: 900px; margin: 0 auto; }
// .min-w-100 { min-width: 100px; }

// /* Pointer events none ensures clicks pass THROUGH the visual line to the buttons below */
// .process-connector { position: absolute; top: 50%; left: 0; width: 100%; border-top: 2px solid var(--ui-border); z-index: 0; transform: translateY(-40px); pointer-events: none; }
// .step-icon-box { width: 72px; height: 72px; position: relative; z-index: 1; }
// .action-header { letter-spacing: 1px; }

// /* Fixed overlapping layout for selection rows */
// .selection-row { cursor: pointer; transition: all 0.2s; border: 1px solid transparent; z-index: 10; position: relative; }
// .selection-row:hover { transform: translateY(-2px); border-color: var(--brand-primary); }
// .icon-box-56 { width: 56px; height: 56px; }
// .country-code-select { width: 100px; flex-shrink: 0; }
// .badge-autofill { background-color: var(--color-info-bg); border-color: var(--brand-primary); color: var(--brand-primary); font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; border: 1px solid; }
// .form-half-width { width: 100%; }
// @media (min-width: 768px) { .form-half-width { width: 50%; } }
// .animate-spin { animation: spin 1s linear infinite; }
// @keyframes spin { 100% { transform: rotate(360deg); } }
// .btn-completed { cursor: default !important; opacity: 1 !important; transform: none !important; pointer-events: none; background-color: #bfdbfe !important; border-color: #bfdbfe !important; color: #ffffff !important; }
// `;

// --- 3. MOCK DATA & CONSTANTS ---
const LYWOLogoSmall = "https://placehold.co/56x56?text=LOGO";
const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

export const DEFAULT_JOB_DATA = {
  code: "1060AB7",
  position: "Marketing Engineer",
  companyname: "Rapsri Engineering Products Pvt Ltd",
  companyLogo: "/path/to/logo.png",
};

export const JOB_DESCRIPTION_TEXT = `
ROLE: Marketing Engineer
COMPANY: Rapsri Engineering Products Pvt Ltd
JOB ID: 1060AB7

BRIEF JOB DESCRIPTION:
We seek a proactive Marketing Engineer to drive our marketing initiatives and support business growth at Rapsri Engineering Products Pvt Ltd.

JOB DETAILS:
- Industry: Engineering, Technical & Equipment Manufacturing
- Location: Bengaluru
- Compensation: 4.5 to 5.5 LPA
- Type: Full-time
- Qualification: Bachelor's
`;

export const MOCK_JOB_DATA = {
  code: "1060AB7",
  position: "Marketing Engineer",
  aboutJob: "We seek a proactive Marketing Engineer to drive our marketing initiatives and support business growth.",
  companyname: "Rapsri Engineering Products Pvt Ltd",
  companyLogo: "/path/to/logo.png",
  aboutCompany: "Rapsri Engineering Products Pvt Ltd is a leader in Engineering, Technical & Equipment Manufacturing. We specialize in producing high-quality engineering products for global markets.",
  companyDetails: {
    overview: "Rapsri Engineering Products Pvt Ltd is a premier manufacturing entity dedicated to precision and innovation. Our mission is to deliver world-class engineering solutions while upholding values of integrity, quality, and sustainability.",
    industryPresence: "A dominant player in the Engineering, Technical & Equipment Manufacturing sector based in Bengaluru. We have a robust global footprint, exporting to over 30 countries.",
    productsServices: "We specialize in copper and copper alloy castings, gravity die castings, and precision machined components relevant to automotive and electrical industries.",
    culture: "We foster a collaborative and inclusive work environment that values continuous learning. Employees enjoy comprehensive health benefits, flexible work arrangements, and team-building retreats.",
    awards: "Recipient of the 'Excellence in Manufacturing' award 2023 and ISO 9001:2015 certified for quality management systems.",
    growth: "We are expanding our R&D division, offering significant opportunities for internal mobility, leadership training, and skill development programs."
  }
};

export const MOCK_PARSED_DATA = {
  name: "Jane Cooper",
  email: "jane.cooper@example.com",
  phone: "9876543210", 
  currentLocation: "Bengaluru, India",
  educationLevel: "Bachelor's", 
  fieldOfEducation: "Engineering",
  experienceYears: "1-2",
  currentJobTitle: "Junior Marketing Associate", 
  currentCompany: "Tech Solutions Ltd",
  departmentId: "MKT",
  currentIndustry: "Manufacturing",
};

export const MOCK_CUSTOM_QUESTIONS = [
  { id: 1, questionText: "Do you have experience with SEO/SEM tools?", isActive: true },
  { id: 2, questionText: "Are you willing to relocate to Bengaluru if required?", isActive: true },
  { id: 3, questionText: "Do you have a valid passport for potential global travel?", isActive: true },
];

export const MOCK_OPTIONS = {
  education: [
    { label: "High School", value: "High School" },
    { label: "Bachelor's", value: "Bachelor's" },
    { label: "Master's", value: "Master's" },
    { label: "PhD", value: "PhD" },
  ],
  experience: [
    { label: "Fresher", value: "0" },
    { label: "1-3 Years", value: "1-3" },
    { label: "3-5 Years", value: "3-5" },
    { label: "5+ Years", value: "5+" },
  ],
  salary: [
    { label: "₹3L - ₹4.5L", value: "3-4.5" },
    { label: "₹4.5L - ₹5.5L", value: "4.5-5.5" },
    { label: "₹5.5L - ₹8L", value: "5.5-8" },
    { label: "₹8L+", value: "8+" },
  ],
  codes: [
    { dial_code: "+91", code: "IN" },
    { dial_code: "+1", code: "US" },
    { dial_code: "+44", code: "UK" },
  ],
  specialization: [
    { specializationName: "Marketing", specializationId: "MKT" },
    { specializationName: "Engineering", specializationId: "ENG" },
    { specializationName: "Business Administration", specializationId: "BA" },
  ],
  departments: [
    { name: "Marketing", id: "MKT" },
    { name: "Sales", id: "SALES" },
    { name: "Engineering", id: "ENG" },
  ],
  industries: [
    { label: "Manufacturing", value: "MFG" },
    { label: "Technology", value: "TECH" },
    { label: "Consulting", value: "CONS" },
  ],
};


// ==========================================
// 4. SUB-COMPONENTS
// ==========================================

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toast show align-items-center text-white ${type === "success" ? "bg-success" : "bg-danger"} border-0 position-fixed top-0 end-0 m-3 z-1060`}>
      <div className="d-flex">
        <div className="toast-body">{message}</div>
        <button type="button" className="btn-close btn-close-white me-2 m-auto" onClick={onClose}></button>
      </div>
    </div>
  );
};

export const LocalCustomButton = ({ title, handleClick, isLoading, isIcon, variant = "primary", className = "" }) => (
  <button className={`btn btn-${variant} ${className}`} onClick={handleClick} disabled={isLoading}>
    {isLoading ? <span className="spinner-border spinner-border-sm"></span> : <> {title} {isIcon && <Icons.ChevronRight size={18} />} </>}
  </button>
);


export const ResumeUploadModal = ({ isOpen, onClose, onUploadComplete }) => {
  const [isParsing, setIsParsing] = useState(false);
  const [progress, setProgress] = useState(0);

  if (!isOpen) return null;

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setIsParsing(true);
    setProgress(0);

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            setIsParsing(false);
            onUploadComplete(file.name);
          }, 500);
          return 100;
        }
        return prev + 10;
      });
    }, 200);
  };


  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-dialog modal-md">
        <div className="custom-modal-header">
          <h4 className="font-size-lg fw-bold m-0 text-xl">Upload Resume</h4>
          <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
        </div>
        <div className="custom-modal-body">
          {isParsing ? (
            <div className="text-center py-5">
              <Icons.Loader2 className="text-primary mb-3 mx-auto animate-spin" size={40} />
              <h4 className="font-size-lg fmt-3">Parsing Resume...</h4>
              <div className="progress w-75 mx-auto progress-thin">
                <div className="progress-bar bg-primary progress-bar-striped progress-bar-animated" style={{ width: `${progress}%` }}></div>
              </div>
            </div>
          ) : (
            <div className="dropzone py-5 position-relative">
              <Icons.UploadCloud className="text-primary mb-2 mx-auto" size={32} />
              <h4 className="font-size-lg">Drag & drop or click to upload</h4>
              <p className="text-muted text-xs">PDF or DOCX (Max 25MB)</p>
              <input type="file" className="position-absolute w-100 h-100 opacity-0 top-0 start-0 cursor-pointer z-10" onChange={handleFile} onClick={(e) => (e.target.value = null)} accept=".pdf,.doc,.docx" />
            </div>
          )}
        </div>
        {!isParsing && (
          <div className="custom-modal-footer justify-content-end">
            <button className="btn btn-outline-primary" onClick={onClose}>Cancel</button>
          </div>
        )}
      </div>
    </div>
  );
};



export const AboutCompanyModal = ({ isOpen, onClose, data }) => {
  if (!isOpen) return null;
  const details = data.companyDetails || {};
  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-dialog modal-lg">
        <div className="custom-modal-header">
          <h4 className="font-size-xl fw-bold m-0">About {data.companyname}</h4>
          <button className="btn p-0 border-0" onClick={onClose}><Icons.X size={20}/></button>
        </div>
        <div className="custom-modal-body text-muted small lh-base modal-body-scroll">
            <div className="mb-3">
                <h4 className="font-size-lg fw-bold text-dark mb-1">Company Overview</h4>
                <p>{details.overview}</p>
            </div>
            <div className="mb-3">
                <h4 className="font-size-lg fw-bold text-dark mb-1">Industry & Market Presence</h4>
                <p>{details.industryPresence}</p>
            </div>
            <div className="mb-3">
                <h4 className="font-size-lg fw-bold text-dark mb-1">Products & Services</h4>
                <p>{details.productsServices}</p>
            </div>
            <div className="mb-3">
                <h4 className="font-size-lg fw-bold text-dark mb-1">Culture & Work Environment</h4>
                <p>{details.culture}</p>
            </div>
            <div className="mb-3">
                <h4 className="font-size-lg fw-bold text-dark mb-1">Awards & Recognition</h4>
                <p>{details.awards}</p>
            </div>
            <div className="mb-0">
                <h4 className="font-size-lg fw-bold text-dark mb-1">Growth & Opportunities</h4>
                <p>{details.growth}</p>
            </div>
        </div>
        <div className="custom-modal-footer justify-content-end">
            <button className="btn btn-primary btn-sm" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};


const DocumentsModal = ({ isOpen, onClose, details }) => {
  const [purchaseToast, setPurchaseToast] = useState(null);
  const [purchasedItems, setPurchasedItems] = useState([]);

  const handlePurchase = (item) => {
    setPurchaseToast(`Redirecting to payment for ${item}...`);
    setTimeout(() => {
        setPurchaseToast(null);
        if (item === 'Bundle') {
            setPurchasedItems(prev => [...new Set([...prev, 'Personality Report', 'Candidate Summary'])]);
        } else {
            setPurchasedItems(prev => [...new Set([...prev, item])]);
        }
    }, 2000);
  };

  if (!isOpen) return null;
  
  const showResume = true;
  const showPersonalityReport = purchasedItems.includes('Personality Report');
  const showCandidateSummary = purchasedItems.includes('Candidate Summary');
  const allPremiumPurchased = showPersonalityReport && showCandidateSummary;
  
  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-dialog modal-md">
        <div className="custom-modal-header">
          <h4 className="font-size-xl fw-bold m-0">My Documents</h4>
          <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
        </div>
        <div className="custom-modal-body">
            {purchaseToast && (
              <div className="alert alert-success py-2 mb-3 small">{purchaseToast}</div>
            )}

            <div className="d-flex flex-column gap-3 mb-4">
                {showResume && (
                    <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-2">
                            <Icons.FileText className="text-primary" size={20} />
                            <div>
                                <div className="font-size-lg fw-bold">Resume</div>
                                <div className="text-muted text-xs">{details.uploadResumeName || "resume.pdf"}</div>
                            </div>
                        </div>
                        <button className="btn btn-sm btn-outline-primary">View</button>
                    </div>
                )}
                
                <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-2">
                        <Icons.FileText className="text-primary" size={20} />
                        <div className="font-size-lg fw-bold">Job Description</div>
                    </div>
                    <button className="btn btn-sm btn-outline-primary" onClick={() => {
                         const element = document.createElement("a");
                         const file = new Blob([JOB_DESCRIPTION_TEXT], { type: "text/plain" });
                         element.href = URL.createObjectURL(file);
                         element.download = "Rapsri_Marketing_Engineer_JD.txt";
                         document.body.appendChild(element);
                         element.click();
                         document.body.removeChild(element);
                    }}>View</button>
                </div>
                
                {showPersonalityReport && (
                     <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-2">
                            <Icons.BadgeCheck className="text-success" size={20} />
                            <div className="font-size-lg fw-bold">Personality Report</div>
                        </div>
                        <button className="btn btn-sm btn-outline-primary">View</button>
                    </div>
                )}
                
                {showCandidateSummary && (
                     <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-2">
                            <Icons.Star className="text-warning" size={20} />
                            <div className="font-size-lg fw-bold">Candidate Summary</div>
                        </div>
                        <button className="btn btn-sm btn-outline-primary" onClick={() => window.open('/candidate-summary', '_blank')}>View</button>
                    </div>
                )}
            </div>

            {!allPremiumPurchased && (
                <div className="pt-3 border-top">
                    <h4 className="font-size-lg fw-bold mb-3 text-xs text-uppercase text-muted">Unlock Premium Insights</h4>
                    <div className="d-flex flex-column gap-3">
                        {!showPersonalityReport && (
                            <div className="card-pricing standard p-2 d-flex flex-row align-items-center justify-content-between h-auto">
                                <div>
                                    <h4 className="font-size-lg fw-bold text-primary mb-0">Personality Report</h4>
                                    <p className="text-muted mb-0 font-size-base">Detailed insights into your strengths.</p>
                                </div>
                                <div className="text-end">
                                     <div className="fw-bold mb-1 d-flex align-items-center justify-content-end text-lg"><Icons.Money size={14} /> 149</div>
                                     <button className="btn btn-xs btn-primary py-1 px-2" onClick={() => handlePurchase('Personality Report')}>Buy</button>
                                </div>
                            </div>
                        )}
                        
                         {!showCandidateSummary && (
                             <div className="card-pricing standard p-2 d-flex flex-row align-items-center justify-content-between h-auto">
                                <div>
                                    <h4 className="font-size-lg fw-bold text-primary mb-0">Candidate Summary</h4>
                                    <p className="text-muted mb-0 font-size-base">Formatted summary in Word.</p>
                                </div>
                                <div className="text-end">
                                     <div className="fw-bold mb-1 d-flex align-items-center justify-content-end text-lg"><Icons.Money size={14} /> 49</div>
                                     <button className="btn btn-xs btn-primary py-1 px-2" onClick={() => handlePurchase('Candidate Summary')}>Buy</button>
                                </div>
                            </div>
                        )}
                        
                        {!showPersonalityReport && !showCandidateSummary && (
                            <div className="card-pricing premium p-2 d-flex flex-row align-items-center justify-content-between position-relative h-auto">
                                <div className="badge-floating text-xs">10% OFF</div>
                                <div>
                                    <h4 className="font-size-lg fw-bold text-success mb-0">All-in-One Bundle</h4>
                                    <p className="text-muted mb-0 font-size-base">Report + Summary.</p>
                                </div>
                                <div className="text-end">
                                     <div className="fw-bold mb-1 d-flex align-items-center justify-content-end text-lg"><Icons.Money size={14} /> 179</div>
                                     <button className="btn btn-xs btn-success py-1 px-2" onClick={() => handlePurchase('Bundle')}>Buy</button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
      </div>
    </div>
  );
};

export const DemoContextModal = ({ isOpen, onClose, onFill, onShare, onCheckStatus }) => {
  const [view, setView] = useState("selection");
  const [copied, setCopied] = useState(false);

  useEffect(() => { if (isOpen) setView("selection"); setCopied(false); }, [isOpen]);
  if (!isOpen) return null;

  const handleCopyLink = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };


  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-dialog modal-md">
        <div className="custom-modal-header">
          <div className="d-flex align-items-center gap-2">
            {view !== "selection" && (
              <button className="btn p-0 border-0 text-muted" onClick={() => setView("selection")}><Icons.ArrowLeft size={20} /></button>
            )}
            <h4 className="font-size-lg fw-bold m-0">{view === "selection" ? "Select Person" : view === "share" ? "Share Job" : "Welcome Back!"}</h4>
          </div>
          <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
        </div>

        <div className="custom-modal-body">
            {view === "selection" && (
              <div className="row g-3">
                <div className="col-6">
                  <div className="card-interactive p-3 text-center border rounded h-100" onClick={() => { onFill(); onClose(); }}>
                    <div className="mb-2 text-primary d-flex justify-content-center"><Icons.UserPlus size={24} /></div>
                    <h4 className="font-size-lg small fw-bold mb-1">New Candidate</h4>
                    <p className="text-muted mb-0 text-base" style={{textAlign:'center'}}>First time applying</p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card-interactive p-3 text-center border rounded h-100" onClick={() => setView("existing")}>
                    <div className="mb-2 text-success d-flex justify-content-center"><Icons.User size={24} /></div>
                    <h4 className="font-size-lg small fw-bold mb-1">Existing Candidate</h4>
                    <p className="text-muted mb-0 text-base" style={{textAlign:'center'}}>Already in system</p>
                  </div>
                </div>
              </div>
            )}

            {view === "existing" && (
              <div className="text-center">
                <div className="alert alert-info text-start small mb-4">
                  <div className="d-flex gap-2">
                    <Icons.Info size={16} className="flex-shrink-0 mt-1" />
                    <div><strong>Your data already exists.</strong><br />Check application or share job.</div>
                  </div>
                </div>
                <div className="d-flex gap-3 justify-content-center">
                  <button className="btn btn-outline-primary" onClick={() => setView("share")}>Share this Job</button>
                  <button className="btn btn-primary" onClick={() => { onCheckStatus(); onClose(); }}>Check Application Status</button>
                </div>
              </div>
            )}

            {view === "share" && (
              <div>
                <div className="input-group mb-4">
                  <span className="input-group-text bg-light border-end-0"><Icons.Link size={16} /></span>
                  <input type="text" className="form-control bg-light border-start-0 text-muted text-lg" value="[https://jobs.techinnovate.com/1060](https://jobs.techinnovate.com/1060)" readOnly />
                  <button className="btn btn-primary" onClick={handleCopyLink}>{copied ? <Icons.Check size={16} /> : "Copy"}</button>
                </div>
                <div className="row g-3">
                   <div className="col-6"><button className="btn btn-outline-secondary w-100 d-flex gap-2 py-2 justify-content-center" onClick={() => onShare("WhatsApp")}><Icons.WhatsApp size={18} className="text-success"/> WhatsApp</button></div>
                   <div className="col-6"><button className="btn btn-outline-secondary w-100 d-flex gap-2 py-2 justify-content-center" onClick={() => onShare("LinkedIn")}><Icons.Linkedin size={18} className="text-primary"/> LinkedIn</button></div>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};


// ==========================================
// 5. MAIN COMPONENT (App)
// ==========================================
const App = (props) => {
  const {
    industries = MOCK_OPTIONS.industries, 
    specialization = MOCK_OPTIONS.specialization,
    departments = MOCK_OPTIONS.departments,
    customQuestion = MOCK_CUSTOM_QUESTIONS,
  } = props;

  const [details, setDetails] = useState({
    name: "", email: "", countryCode: "+91", phone: "", educationLevel: "", fieldOfEducation: "",
    experienceYears: "", currentJobTitle: "", currentCompany: "", departmentId: "", currentIndustry: "",
    expectedSalary: "", currentLocation: "", availableFrom: "", noticePeriodBuyout: "", 
    uploadResumeName: "", preferredLocation: "", preferredJobType: "", additionalComments: ""
  });

  const [stepStatus, setStepStatus] = useState({ application: 'completed', personality: 'pending', quiz: 'pending' });
  const [purchasedItems, setPurchasedItems] = useState([]);
  const [purchaseToast, setPurchaseToast] = useState(null);

  const jobData = { ...DEFAULT_JOB_DATA, ...MOCK_JOB_DATA };
  const [currentStep, setCurrentStep] = useState(1);
  const [applicationFlow, setApplicationFlow] = useState("quick");
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showDemoModal, setShowDemoModal] = useState(false);
  const [toastMsg, setToastMsg] = useState(null);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => setDetails((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 25 * 1024 * 1024) {
        setToastMsg({ type: "error", message: "File too large" });
      } else {
        setDetails({ ...details, uploadResumeName: file.name });
        setErrors({ ...errors, resume: "" });
      }
    }
  };

  const handleResumeParsed = (fileName) => {
    setShowResumeModal(false);
    setDetails((prev) => ({ ...prev, uploadResumeName: fileName, ...MOCK_PARSED_DATA }));
    setToastMsg({ type: "success", message: "Resume parsed successfully!" });
    setCurrentStep(2);
  };

  const handleDemoFillClick = () => { currentStep === 2 ? setShowDemoModal(true) : fillMockData(); };
  const handleCheckApplicationStatus = () => { fillMockData(); setIsSubmitted(true); };

  const fillMockData = () => {
    const mockUpdates = {
      name: "Jane Cooper", email: "jane.cooper@example.com", phone: "9876543210", currentLocation: "Bengaluru, KA",
      educationLevel: "Bachelor's", fieldOfEducation: "MKT", experienceYears: "1-3", currentJobTitle: "Marketing Associate",
      currentCompany: "Tech Solutions", currentSalary: "4.5-5.5", availableFrom: "2026-02-01", expectedSalary: "4.5-5.5",
      noticePeriodBuyout: "No", customQuestion1: "Yes", customQuestion2: "Yes", customQuestion3: "Yes",
      preferredLocation: "Bengaluru", additionalComments: "I am eager to join the team and contribute to your marketing goals.",
    };
    if (applicationFlow === "standard") mockUpdates.uploadResumeName = "jane_cooper_resume.pdf";
    setDetails((prev) => ({ ...prev, ...mockUpdates }));
    setErrors({});
    setToastMsg({ type: "success", message: "✨ Demo data filled!" });
  };

  const handleShareJob = (platform) => {
    setToastMsg({ type: "success", message: `Job Shared via ${platform || "Link"}!` });
    if (platform) setShowDemoModal(false);
  };

  const handleDownloadJD = () => {
    const element = document.createElement("a");
    const file = new Blob([JOB_DESCRIPTION_TEXT], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "Rapsri_Marketing_Engineer_JD.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    setToastMsg({ type: "success", message: "JD Downloaded" });
  };

  const handleStartPersonality = () => {
    setToastMsg({ type: "success", message: "Personality Test Started..." });
    setTimeout(() => {
        setStepStatus(prev => ({ ...prev, personality: 'completed' }));
        setToastMsg({ type: "success", message: "Personality Test Completed!" });
    }, 1500);
  };

  const handleStartQuiz = () => {
    setToastMsg({ type: "success", message: "Short Quiz Started..." });
    setTimeout(() => {
        setStepStatus(prev => ({ ...prev, quiz: 'completed' }));
        setToastMsg({ type: "success", message: "Short Quiz Completed!" });
    }, 1500);
  };

  const handlePurchase = (item) => {
    setPurchaseToast(`Redirecting to payment for ${item}...`);
    setTimeout(() => {
        setPurchaseToast(null);
        if (item === 'Bundle') {
            setPurchasedItems(prev => [...new Set([...prev, 'Personality Report', 'Candidate Summary'])]);
        } else {
            setPurchasedItems(prev => [...new Set([...prev, item])]);
        }
    }, 2000);
  };

  const allStepsCompleted = stepStatus.application === 'completed' && stepStatus.personality === 'completed' && stepStatus.quiz === 'completed';

  const validateCurrentStep = () => {
    const newErrors = {};
    let isValid = true;
    const requireField = (field, label) => {
      if (!details[field] || details[field] === "") { newErrors[field] = `${label || field} is required`; isValid = false; }
    };

    if (currentStep === 2) {
      requireField("name", "Full Name"); requireField("email", "Email"); requireField("phone", "Phone Number");
      if (details.email && !isValidEmail(details.email)) { newErrors.email = "Invalid email format"; isValid = false; }
      requireField("currentLocation", "Location");
    } else if (currentStep === 3) {
      requireField("educationLevel", "Education Level"); requireField("fieldOfEducation", "Field of Education"); requireField("experienceYears", "Experience");
      if (details.experienceYears !== "0") { requireField("currentJobTitle", "Job Title"); requireField("currentCompany", "Company"); requireField("currentSalary", "Current Salary"); }
    } else if (currentStep === 4) {
      if (applicationFlow === "standard" && !details.uploadResumeName) { newErrors.resume = "Please upload your resume"; isValid = false; }
      requireField("expectedSalary", "Expected Salary"); requireField("availableFrom", "Availability Date"); requireField("noticePeriodBuyout", "Buyout Option");
      customQuestion.forEach((q, i) => {
        const key = `customQuestion${i + 1}`;
        if (!details[key]) { newErrors[key] = "Please answer this question"; isValid = false; }
      });
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleNext = () => {
    if (validateCurrentStep()) {
      if (currentStep < 4) { setCurrentStep((prev) => prev + 1); window.scrollTo(0, 0); } 
      else { setToastMsg({ type: "success", message: "Application Submitted Successfully!" }); setStepStatus(prev => ({ ...prev, application: 'completed' })); setIsSubmitted(true); }
    } else {
      setToastMsg({ type: "error", message: "Please fix the errors." });
    }
  };

  const renderInput = ({ label, name, icon: Icon, type = "text", ...rest }) => (
    <div className="mb-2">
      <label className="form-label d-flex justify-content-between align-items-center mb-1">
        <span>{label} {rest.required && <span className="text-danger">*</span>}</span>
        {applicationFlow === "quick" && details[name] && (
          <span className="d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill badge-autofill text-xs" title="Auto-filled from Resume">
            <Icons.Zap size={10} fill="currentColor" /> Auto-filled
          </span>
        )}
      </label>
      <div className="input-group">
        <span className="input-group-text bg-white border-end-0"><Icon size={18} /></span>
        <input type={type} name={name} className={`form-control bg-white border-start-0 ${errors[name] ? "is-invalid" : ""}`} value={details[name] || ""} onChange={handleInputChange} {...rest} />
      </div>
      {errors[name] && <div className="text-danger small mt-1">{errors[name]}</div>}
    </div>
  );

  if (isSubmitted) {
    const showPersonalityReport = purchasedItems.includes('Personality Report');
    const showCandidateSummary = purchasedItems.includes('Candidate Summary');
    const allPremiumPurchased = showPersonalityReport && showCandidateSummary;
    const completedCount = [stepStatus.application, stepStatus.personality, stepStatus.quiz].filter(s => s === 'completed').length;
    const remainingCount = 3 - completedCount;


      return (
      <div className="ds-wrapper w-100">
        {purchaseToast && (
            <div className={`toast show align-items-center text-white bg-success border-0 position-fixed top-0 end-0 m-3 z-1060`}>
                <div className="d-flex"><div className="toast-body">{purchaseToast}</div></div>
            </div>
        )}
        <div className="container content-area mt-3 bg-white border-0 shadow-none">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-11">
              <div className="p-4">
                <div className="mb-4 text-primary d-flex justify-content-center">
                  <Icons.ThumbsUp width={80} height={80} strokeWidth={1.5} />
                </div>
               <h2 className="fw-bold mb-2 text-2xl text-center">Application Status</h2>
<p className="text-muted mb-5 text-base text-center mx-auto" style={{ maxWidth: '600px' }}>
  Hello <strong className="text-dark">{details.name || "Jane Cooper"}</strong>, 
  here is the status of your application process for <strong className="text-dark">{jobData.position}</strong>.
</p>
                <div className="d-grid gap-3 max-w-400 mb-5">
                  <div className="w-100" title="Submit your resume and basic details to get started.">
                    <button className="btn btn-primary py-2 px-3 w-100 fw-bold" onClick={() => setIsSubmitted(false)}>Edit Application</button>
                  </div>
                  <div className="w-100" title="Showcase your strengths better than a stressful screening call. This ensures a great fit for the role and team, setting you up for success.">
                    <button 
                        className={`btn py-2 px-3 w-100 fw-bold ${stepStatus.personality === 'completed' ? 'btn-completed' : 'btn-primary'}`}
                        onClick={stepStatus.personality === 'pending' ? handleStartPersonality : undefined}
                    >
                        {stepStatus.personality === 'completed' ? "Personality Test completed" : "Start Personality Test"}
                    </button>
                  </div>
                  <div className="w-100" title="A quick check of your technical knowledge relevant to the role.">
                     <button 
                        className={`btn py-2 px-3 w-100 fw-bold ${stepStatus.quiz === 'completed' ? 'btn-completed' : 'btn-primary'}`}
                        onClick={stepStatus.quiz === 'pending' ? handleStartQuiz : undefined}
                    >
                        {stepStatus.quiz === 'completed' ? "Short Quiz completed" : "Start Short Quiz"}
                    </button>
                  </div>
                </div>

                <div className="animate-fade-in pt-4 border-top max-w-500 mx-auto">
                    {allStepsCompleted ? (
                        <div className="mb-5 text-center px-3">
                            <h4 className="fw-bold mb-2 text-xl">We have your Complete Application</h4>
                            <p className="text-muted text-base mb-0">Thank you for your Time. We will reach out to you soon.</p>
                        </div>
                    ) : (
                        <div className="mb-5 text-center px-3">
                            <h4 className="fw-bold mb-2 text-lg text-dark">{completedCount} of 3 Steps Complete</h4>
                            <p className="text-muted text-base mb-0">
                                Kindly complete the remaining {remainingCount} step{remainingCount !== 1 ? 's' : ''} by clicking the start option provided above.
                            </p>
                        </div>
                    )}
                    
                    <div className="max-w-500 mx-auto text-start mb-5">
                        <h4 className="fw-bold mb-4 text-lg text-center text-dark">My Documents</h4>
                        <div className="d-flex flex-column gap-3">
                            <div className="p-3 border rounded-3 d-flex justify-content-between align-items-center bg-white shadow-sm">
                                <div className="d-flex align-items-center gap-3">
                                    <div className="text-primary bg-primary bg-opacity-10 p-2 rounded"><Icons.FileText size={20} /></div>
                                    <div>
                                        <div className="fw-bold text-base text-dark">Resume</div>
                                        <div className="text-muted text-xs">{details.uploadResumeName || "jane_cooper_resume.pdf"}</div>
                                    </div>
                                </div>
                                <button className="btn btn-sm btn-outline-primary px-4 py-1 rounded-pill">View</button>
                            </div>
                            
                            <div className="p-3 border rounded-3 d-flex justify-content-between align-items-center bg-white shadow-sm">
                                <div className="d-flex align-items-center gap-3">
                                    <div className="text-primary bg-primary bg-opacity-10 p-2 rounded"><Icons.FileText size={20} /></div>
                                    <div className="fw-bold text-base text-dark">Job Description</div>
                                </div>
                                <button className="btn btn-sm btn-outline-primary px-4 py-1 rounded-pill" onClick={handleDownloadJD}>View</button>
                            </div>

                            {showPersonalityReport && (
                                <div className="p-3 border rounded-3 d-flex justify-content-between align-items-center bg-white shadow-sm">
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="text-success bg-success bg-opacity-10 p-2 rounded"><Icons.BadgeCheck size={20} /></div>
                                        <div className="fw-bold text-base text-dark">Personality Report</div>
                                    </div>
                                    <button className="btn btn-sm btn-outline-primary px-4 py-1 rounded-pill">View</button>
                                </div>
                            )}
                            
                            {showCandidateSummary && (
                                <div className="p-3 border rounded-3 d-flex justify-content-between align-items-center bg-white shadow-sm">
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="text-warning bg-warning bg-opacity-10 p-2 rounded"><Icons.Star size={20} /></div>
                                        <div className="fw-bold text-base text-dark">Candidate Summary</div>
                                    </div>
                                    <button className="btn btn-sm btn-outline-primary px-4 py-1 rounded-pill" onClick={() => window.open('/candidate-summary', '_blank')}>View</button>
                                </div>
                            )}
                        </div>
                    </div>

                    {!allPremiumPurchased && (
                        <div className="max-w-500 mx-auto text-start">
                            <hr className="mb-4 text-muted opacity-25" />
                            <h4 className="font-size-base fw-bold mb-3 text-muted">Unlock Premium Insights</h4>
                            <div className="d-flex flex-column gap-3">
                                {!showPersonalityReport && (
                                    <div className="border rounded-3 p-3 d-flex justify-content-between align-items-center bg-white" style={{ borderColor: 'var(--brand-primary)' }}>
                                        <div>
                                            <h4 className="font-size-base fw-bold text-primary mb-1">Personality Report</h4>
                                            <p className="text-muted mb-0 text-xs">Detailed insights into your strengths.</p>
                                        </div>
                                        <div className="text-end">
                                            <div className="fw-bold text-dark mb-2 text-base d-flex justify-content-end align-items-center"><span className="me-1 fw-normal">₹</span> 149</div>
                                            <button className="btn btn-primary btn-sm px-4 py-1 rounded-pill w-100 fw-bold" onClick={() => handlePurchase('Personality Report')}>Buy</button>
                                        </div>
                                    </div>
                                )}
                                {!showCandidateSummary && (
                                    <div className="border rounded-3 p-3 d-flex justify-content-between align-items-center bg-white" style={{ borderColor: 'var(--brand-primary)' }}>
                                        <div>
                                            <h4 className="font-size-base fw-bold text-primary mb-1">Candidate Summary</h4>
                                            <p className="font-size-base text-muted mb-0">Formatted summary in Word.</p>
                                        </div>
                                        <div className="text-end">
                                            <div className="fw-bold text-dark mb-2 text-base d-flex justify-content-end align-items-center"><span className="me-1 fw-normal">₹</span> 49</div>
                                            <button className="btn btn-primary btn-sm px-4 py-1 rounded-pill w-100 fw-bold" onClick={() => handlePurchase('Candidate Summary')}>Buy</button>
                                        </div>
                                    </div>
                                )}
                                {!showPersonalityReport && !showCandidateSummary && (
                                    <div className="border border-2 border-success rounded-3 p-3 d-flex justify-content-between align-items-center bg-white position-relative mt-2">
                                        <div className="badge bg-success text-white position-absolute top-0 start-50 translate-middle rounded-pill px-3 py-1 text-xs fw-bold">10% OFF</div>
                                        <div>
                                            <h4 className="font-size-base fw-bold text-success mb-1">All-in-One Bundle</h4>
                                            <p className="font-size-base text-muted mb-0">Report + Summary.</p>
                                        </div>
                                        <div className="text-end">
                                            <div className="fw-bold text-dark mb-2 text-base d-flex justify-content-end align-items-center"><span className="me-1 fw-normal">₹</span> 179</div>
                                            <button className="btn btn-success text-white btn-sm px-4 py-1 rounded-pill w-100 fw-bold" style={{backgroundColor: '#198754', borderColor: '#198754'}} onClick={() => handlePurchase('Bundle')}>Buy</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }



  // --- RENDER: MAIN WIZARD ---
   return (
    <div className="ds-wrapper w-100">
      <ResumeUploadModal isOpen={showResumeModal} onClose={() => setShowResumeModal(false)} onUploadComplete={handleResumeParsed} />
      <AboutCompanyModal isOpen={showAboutModal} onClose={() => setShowAboutModal(false)} data={jobData} />
      <DemoContextModal isOpen={showDemoModal} onClose={() => setShowDemoModal(false)} onFill={fillMockData} onShare={handleShareJob} onCheckStatus={handleCheckApplicationStatus} />
      {toastMsg && <Toast {...toastMsg} onClose={() => setToastMsg(null)} />}

      <div className={`container content-area mt-3 w-100 ${currentStep === 1 ? 'step-one-clean' : ''}`}>
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-12">
            <div className="bg-white border rounded-3 p-3 mb-3 shadow-sm">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex gap-3 align-items-center">
                        <div className="border rounded d-flex align-items-center justify-content-center bg-light text-secondary avatar-56">
                            <span className="font-size-baselogo-text">Logo</span>
                        </div>
                        <div>
                            <h3 className="font-size-xl mb-1 text-dark" style={{fontWeight:'bold'}}>{jobData.position}</h3>
                            <div className="font-size-base text-muted d-flex align-items-center gap-2 ">
                                <span>{jobData.companyname}</span>
                                <span className="font-size-lg text-muted opacity-25">|</span>
                                <span className="font-size-lg d-flex align-items-center gap-1 text-dark">
                                    <Icons.BadgeCheck size={15} className="text-primary" /> {jobData.code}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column align-items-end gap-1">
                        <button className="font-size-lg btn btn-link p-0 text-decoration-none text-primary fw-bold d-flex align-items-center gap-1 cursor-pointer z-10" onClick={handleDownloadJD}>
                            <Icons.Download size={16} /> Job Desc
                        </button>
                        <button className="font-size-lg btn btn-link p-0 text-decoration-underline text-primary fw-bold text-lg cursor-pointer z-10" onClick={() => setShowAboutModal(true)}>
                            About Us
                        </button>
                    </div>
                </div>
            </div>

            {currentStep === 1 ? (
                 <div className="animate-fade-in py-2">
                    <div className="text-center mb-5 mt-3">
                        <h3 className="fw-bold h3 mb-2 px-3">Thank you for your Interest in the Job.</h3>
                        <div className="d-flex align-items-center justify-content-center gap-2 text-muted mb-2">
                            <Icons.Clock size={14} />
                            <span className="font-size-lg">The process has 3 Steps and will take only 15-20 minutes</span>
                        </div>
                    </div>

                    <div className="row g-3 mb-4 justify-content-center position-relative">
                        <div className="d-none d-md-block process-connector"></div>
                        <div className="col-md-4 text-center position-relative">
                            <div className="mb-3 text-primary bg-white rounded-circle shadow-sm d-inline-flex align-items-center justify-content-center step-icon-box"><Icons.FileText size={32} /></div>
                            <h4 className="font-size-lg fw-bold mb-1">Application</h4>
                            <p className="font-size-base text-muted px-3" style={{textAlign:'center'}} >Share your resume and basic contact info.</p>
                        </div>
                        <div className="col-md-4 text-center position-relative">
                            <div className="mb-3 text-info bg-white rounded-circle shadow-sm d-inline-flex align-items-center justify-content-center step-icon-box"><Icons.User size={32} /></div>
                            <h4 className="font-size-lg fw-bold mb-1">Personality Fit</h4>
                            <p className="font-size-base text-muted px-3" style={{textAlign:'center'}}>A quick assessment of your work style traits.</p>
                        </div>
                        <div className="col-md-4 text-center position-relative">
                            <div className="mb-3 text-warning bg-white rounded-circle shadow-sm d-inline-flex align-items-center justify-content-center step-icon-box"><Icons.CheckCircle size={32} /></div>
                            <h4 className="font-size-lg fw-bold mb-1">Short Quiz(If Avail.)</h4>
                            <p className="font-size-base text-muted  px-3" style={{textAlign:'center'}}>A brief check of your skills relevant to the role.</p>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <p className="font-size-base text-center text-muted fw-bold mb-4 action-header">2 Ways to Apply</p>
                            <div className="d-flex align-items-center p-4 mb-3 bg-white rounded-3 shadow-sm position-relative overflow-hidden selection-row" onClick={() => { setApplicationFlow("quick"); setShowResumeModal(true); }}>
                                <div className="bg-primary bg-opacity-10 p-3 rounded-circle me-3 text-primary d-flex align-items-center justify-content-center icon-box-56"><Icons.Zap size={24} /></div>
                                <div className="flex-grow-1">
                                    <h4 className="font-size-lg fw-bold mb-1 text-dark">Quick Apply</h4>
                                    <p className="font-size-base text-muted mb-0">Upload Resume to pre fill</p>
                                </div>
                                <div className="text-primary ms-3"><Icons.ChevronRight size={24} /></div>
                            </div>
                            <div className="d-flex align-items-center p-4 bg-white rounded-3 shadow-sm position-relative overflow-hidden selection-row" onClick={() => { setApplicationFlow("standard"); setCurrentStep(2); }}>
                                <div className="bg-secondary bg-opacity-10 p-3 rounded-circle me-3 text-secondary d-flex align-items-center justify-content-center icon-box-56"><Icons.Edit size={24} /></div>
                                <div className="flex-grow-1">
                                    <h4 className="font-size-lg fw-bold mb-1 text-dark">Manual Entry</h4>
                                    <p className="font-size-base text-muted mb-0">Start from Scratch</p>
                                </div>
                                <div className="text-muted ms-3"><Icons.ChevronRight size={24} /></div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="card-std d-flex flex-column card-auto-height z-10">
                <div className="flex-grow-1">
                    {currentStep === 2 && (
                    <div className="animate-fade-in">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="font-size-lg fw-bold mb-0">Basic Info</h4>
                        <button onClick={handleDemoFillClick} className="font-size-lg btn btn-link text-decoration-none text-muted p-0 d-flex align-items-center gap-1"><Icons.Sparkles size={14} /> Demo</button>
                        </div>
                        {renderInput({ label: "Full Name", name: "name", icon: Icons.User, required: true })}
                        {renderInput({ label: "Email", name: "email", icon: Icons.Mail, required: true })}
                        <div className="mb-2">
                        <label className="form-label mb-1">Phone <span className="text-danger">*</span></label>
                        <div className="d-flex gap-2 w-100">
                            <div className="country-code-select">
                            <select className="form-select" name="countryCode" value={details.countryCode} onChange={handleInputChange}>
                                {MOCK_OPTIONS.codes.map((c) => (<option key={c.dial_code} value={c.dial_code}>{c.dial_code}</option>))}
                            </select>
                            </div>
                            <input type="tel" className="form-control flex-grow-1" name="phone" value={details.phone} onChange={handleInputChange} />
                        </div>
                        </div>
                        {renderInput({ label: "Location", name: "currentLocation", icon: Icons.MapPin, required: true })}
                    </div>
                    )}

                    {currentStep === 3 && (
                    <div className="animate-fade-in">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="font-size-lg fw-bold mb-0">Education & Experience</h4>
                        <button onClick={handleDemoFillClick} className="font-size-lg btn btn-link text-decoration-none text-muted p-0 d-flex align-items-center gap-1"><Icons.Sparkles size={14} /> Demo</button>
                        </div>
                        <div className="mb-2">
                        <label className="form-label mb-1">Education Level <span className="text-danger">*</span></label>
                        <select className="form-select" name="educationLevel" value={details.educationLevel} onChange={handleInputChange}>
                            <option value="">Select...</option>
                            {MOCK_OPTIONS.education.map((e) => (<option key={e.value} value={e.value}>{e.label}</option>))}
                        </select>
                        </div>
                        <div className="mb-2">
                        <label className="form-label mb-1">Field of Education <span className="text-danger">*</span></label>
                        <select className="form-select" name="fieldOfEducation" value={details.fieldOfEducation} onChange={handleInputChange}>
                            <option value="">Select...</option>
                            {specialization.map((s) => (<option key={s.specializationId} value={s.specializationId}>{s.specializationName}</option>))}
                        </select>
                        </div>
                        <div className="mb-2">
                        <label className="form-label mb-1">Experience (in years) <span className="text-danger">*</span></label>
                        <select className="form-select" name="experienceYears" value={details.experienceYears} onChange={handleInputChange}>
                            <option value="">Select...</option>
                            {MOCK_OPTIONS.experience.map((e) => (<option key={e.value} value={e.value}>{e.label}</option>))}
                        </select>
                        </div>
                        {details.experienceYears !== "0" && (
                        <div className="p-3 bg-light rounded border mt-2">
                            <h4 className="font-size-lg fw-bold mb-2">Current Employment</h4>
                            {renderInput({ label: "Job Title", name: "currentJobTitle", icon: Icons.Briefcase, required: true })}
                            {renderInput({ label: "Company", name: "currentCompany", icon: Icons.Building2, required: true })}
                            <div className="mb-2">
                            <label className="form-label mb-1">Current Salary <span className="text-danger">*</span></label>
                            <select className="form-select" name="currentSalary" value={details.currentSalary} onChange={handleInputChange}>
                                <option value="">Select...</option>
                                {MOCK_OPTIONS.salary.map((s) => (<option key={s.value} value={s.value}>{s.label}</option>))}
                            </select>
                            </div>
                            <div className="mb-2">
                            <label className="form-label mb-1">Department</label>
                            <select className="form-select" name="departmentId" value={details.departmentId} onChange={handleInputChange}>
                                <option value="">Select...</option>
                                {departments.map((d) => (<option key={d.id} value={d.id}>{d.name}</option>))}
                            </select>
                            </div>
                            <div className="mb-2">
                            <label className="form-label mb-1">Industry</label>
                            <select className="form-select" name="currentIndustry" value={details.currentIndustry} onChange={handleInputChange}>
                                <option value="">Select...</option>
                                {industries.map((i) => (<option key={i.label} value={i.label}>{i.label}</option>))}
                            </select>
                            </div>
                        </div>
                        )}
                    </div>
                    )}

                    {currentStep === 4 && (
                    <div className="animate-fade-in">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="font-size-lg fw-bold mb-0">Additional Info</h4>
                        <button onClick={handleDemoFillClick} className="font-size-lg btn btn-link text-decoration-none text-muted p-0 d-flex align-items-center gap-1"><Icons.Sparkles size={14} /> Demo</button>
                        </div>
                        {applicationFlow === "standard" ? (
                        <div className="dropzone mb-3 py-3 position-relative text-center border rounded bg-light">
                            <Icons.UploadCloud className="text-primary mb-2 mx-auto" size={28} />
                            <h4 className="font-size-lg">Click to Upload Resume</h4>
                            <p className="small text-muted mb-0 font-size-base">PDF, DOCX (Max 25MB)</p>
                            <input type="file" className="position-absolute w-100 h-100 opacity-0 top-0 start-0 cursor-pointer z-10" onChange={handleFileChange} onClick={(e) => (e.target.value = null)} />
                            {details.uploadResumeName && <div className="mt-2 text-primary small fw-bold">{details.uploadResumeName}</div>}
                            {errors.resume && <div className="text-danger small mt-2">{errors.resume}</div>}
                        </div>
                        ) : (
                        <div className="border rounded p-3 mb-3 d-flex justify-content-between align-items-center bg-light">
                            <div className="d-flex align-items-center gap-3">
                                <div className="bg-white p-2 rounded border text-primary"><Icons.FileText size={20} /></div>
                                <div className="overflow-hidden">
                                    <h4 className="small fw-bold mb-0 text-dark">Uploaded Resume</h4>
                                    <p className="small text-muted mb-0 text-truncate" title={details.uploadResumeName}>{details.uploadResumeName}</p>
                                </div>
                            </div>
                            <button className="btn btn-sm btn-outline-primary bg-white cursor-pointer z-10" onClick={() => setShowResumeModal(true)}>Change</button>
                        </div>
                        )}
                        <div className="row g-2 mb-2">
                        <div className="col-6">
                            <label className="form-label mb-1">Expected Salary <span className="text-danger">*</span></label>
                            <select className="form-select" name="expectedSalary" value={details.expectedSalary} onChange={handleInputChange}>
                            <option value="">Select...</option>
                            {MOCK_OPTIONS.salary.map((s) => (<option key={s.value} value={s.value}>{s.label}</option>))}
                            </select>
                        </div>
                        <div className="col-6">
                            <label className="form-label mb-1">Available From <span className="text-danger">*</span></label>
                            <input type="date" className="form-control" name="availableFrom" value={details.availableFrom} onChange={handleInputChange} />
                        </div>
                        </div>
                        <div className="mb-2 d-flex justify-content-between align-items-center">
                        <label className="form-label mb-0">Buy Out Option? <span className="text-danger">*</span></label>
                        <div className="d-flex gap-3">
                            {["Yes", "No"].map((o) => (
                            <div key={o} className="form-check mb-0 d-flex align-items-center gap-2">
                                <input className="form-check-input mt-0" type="radio" name="noticePeriodBuyout" id={`buyout-${o}`} value={o} checked={details.noticePeriodBuyout === o} onChange={handleInputChange} />
                                <label className="form-check-label cursor-pointer mb-0" htmlFor={`buyout-${o}`}>{o}</label>
                            </div>
                            ))}
                        </div>
                        </div>

                        <h4 className="font-size-lgfw-bold mt-4 mb-3 border-bottom pb-2">Job Related Questions</h4>

                        {customQuestion.map((q, i) => (
                        <div key={i} className="mb-2">
                            <div className="d-flex justify-content-between align-items-center">
                                <label className="form-label mb-0">{q.questionText} <span className="text-danger">*</span></label>
                                <div className="d-flex gap-3">
                                {["Yes", "No"].map((o) => (
                                    <div key={o} className="form-check mb-0 d-flex align-items-center gap-2">
                                    <input className="form-check-input mt-0" type="radio" name={`customQuestion${i + 1}`} id={`q${i}-${o}`} value={o} checked={details[`customQuestion${i + 1}`] === o} onChange={handleInputChange} />
                                    <label className="form-check-label cursor-pointer mb-0" htmlFor={`q${i}-${o}`}>{o}</label>
                                    </div>
                                ))}
                                </div>
                            </div>
                            {errors[`customQuestion${i + 1}`] && <div className="text-danger small text-end mt-1">{errors[`customQuestion${i + 1}`]}</div>}
                        </div>
                        ))}
                        <div className="mb-2 d-flex justify-content-between align-items-center">
                        <label className="form-label mb-0">Preferred Work Location</label>
                        <div className="form-half-width">
                            <select className="form-select" name="preferredLocation" value={details.preferredLocation} onChange={handleInputChange}>
                            <option value="">Select...</option>
                            <option value="Bengaluru">Bengaluru</option>
                            <option value="Mumbai">Mumbai</option>
                            <option value="Delhi">Delhi</option>
                            </select>
                        </div>
                        </div>
                        <div className="mb-2 d-flex justify-content-between align-items-start">
                        <label className="form-label mb-0 mt-1">Additional Comments</label>
                        <div className="form-half-width">
                            <textarea className="form-control" rows={3} name="additionalComments" value={details.additionalComments} onChange={handleInputChange} placeholder="Write any additional information here..." />
                        </div>
                        </div>
                    </div>
                    )}
                </div>
                </div>
            )}
          </div>
        </div>
      </div>

      {!isSubmitted && currentStep > 1 && (
        <div className="sticky-action-bar position-fixed bottom-0 start-0 w-100 z-1020">
          <div className="container w-100 d-flex justify-content-between align-items-center px-0 max-w-900">
            <div className="min-w-100">
              <LocalCustomButton title="Back" handleClick={() => setCurrentStep((c) => c - 1)} variant="outline-primary" />
            </div>
            <div className="min-w-100 text-end">
              <LocalCustomButton title={currentStep === 4 ? "Submit" : "Next"} handleClick={handleNext} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;

